/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Duration_Too_ShortInputs */

const en_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event duration must be at least 2 seconds to record.`)
};

const fr_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La durée de l'événement doit être d'au moins 2 secondes pour enregistrer.`)
};

const de_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ereignis muss mindestens 2 Sekunden dauern, um aufgezeichnet zu werden.`)
};

const it_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per poter essere registrato, l'evento deve durare almeno 2 secondi.`)
};

const ru_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для записи длительность события должна составлять не менее 2 секунд.`)
};

const es_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La duración del evento debe ser de al menos 2 segundos para poder grabar.`)
};

const zh_cn2_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件持续时间必须至少为 2 秒才能被记录。`)
};

const ja_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録するにはイベントの継続時間が少なくとも 2 秒である必要があります。`)
};

const hi_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग के लिए इवेंट की अवधि कम से कम 2 सेकंड होनी चाहिए।`)
};

const pt_pt2_audio_recorder_duration_too_short = /** @type {(inputs: Audio_Recorder_Duration_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A duração do evento deve ser de pelo menos 2 segundos para ser gravada.`)
};

/**
* | output |
* | --- |
* | "Event duration must be at least 2 seconds to record." |
*
* @param {Audio_Recorder_Duration_Too_ShortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_duration_too_short = /** @type {((inputs?: Audio_Recorder_Duration_Too_ShortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Duration_Too_ShortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_duration_too_short(inputs)
	if (locale === "de") return de_audio_recorder_duration_too_short(inputs)
	if (locale === "it") return it_audio_recorder_duration_too_short(inputs)
	if (locale === "ru") return ru_audio_recorder_duration_too_short(inputs)
	if (locale === "es") return es_audio_recorder_duration_too_short(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_duration_too_short(inputs)
	if (locale === "ja") return ja_audio_recorder_duration_too_short(inputs)
	if (locale === "hi") return hi_audio_recorder_duration_too_short(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_duration_too_short(inputs)
	return en_audio_recorder_duration_too_short(inputs)
});